import React from "react";
import { Box, Typography } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

// セパレーター幅を固定して、Dot サイズが違っても線の中心を揃える
const SEPARATOR_WIDTH = 54; // 最大 Dot(50px) + 余白

const itemSx = {
  "&::before": { display: "none" },
};

const separatorSx = {
  width: SEPARATOR_WIDTH,
  minWidth: SEPARATOR_WIDTH,
  alignItems: "center",
};

const connectorSx = {
  bgcolor: "#9e9e9e",
  width: "2px",
  flexGrow: 1,
  minHeight: "16px",
  mx: "auto",
};

const markerDotSx = {
  width: 50,
  height: 50,
  borderColor: "#333",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "center",
  p: 0,
  my: 0,
};

const scheduleDotSx = {
  width: 30,
  height: 30,
  borderColor: "#333",
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "center",
  p: 0,
  my: 0,
};

const bubbleSx = {
  borderRadius: "8px",
  fontSize: "10px",
  color: "#fff",
  px: 1.5,
  py: 0.5,
  alignSelf: "flex-start",
};

function TravelTimeline({ days }) {
  const items = [];

  days.forEach((day, dayIndex) => {
    // 日付マーカー
    const isFirst = dayIndex === 0;
    items.push(
      <TimelineItem key={`day-${dayIndex}`} sx={itemSx}>
        <TimelineSeparator sx={separatorSx}>
          {!isFirst && <TimelineConnector sx={connectorSx} />}
          <TimelineDot variant="outlined" sx={markerDotSx}>
            <Typography
              sx={{
                fontSize: "9px",
                color: "#333",
                lineHeight: 1,
                textAlign: "center",
              }}
            >
              {day.date}
            </Typography>
          </TimelineDot>
          <TimelineConnector sx={connectorSx} />
        </TimelineSeparator>
        <TimelineContent />
      </TimelineItem>
    );

    // スケジュールアイテム
    day.schedules.forEach((schedule, scheduleIndex) => {
      items.push(
        <TimelineItem key={`sched-${dayIndex}-${scheduleIndex}`} sx={itemSx}>
          <TimelineSeparator sx={separatorSx}>
            <TimelineDot variant="outlined" sx={scheduleDotSx}>
              <Typography
                sx={{ fontSize: "10px", color: "#333", lineHeight: 1 }}
              >
                {schedule.time}
              </Typography>
            </TimelineDot>
            <TimelineConnector sx={connectorSx} />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "12px", color: "#333" }}
              >
                {schedule.title}
              </Typography>

              {schedule.budget != null && schedule.budget > 0 && (
                <Box sx={{ ...bubbleSx, bgcolor: "#ffaa00" }}>
                  {new Intl.NumberFormat("ja-JP", {
                    style: "currency",
                    currency: "JPY",
                  }).format(schedule.budget)}
                </Box>
              )}

              {schedule.description && (
                <Box sx={{ ...bubbleSx, bgcolor: "#4fc3f7" }}>
                  {schedule.description}
                </Box>
              )}

              {schedule.links &&
                schedule.links.map(
                  (link, linkIndex) =>
                    link && (
                      <Box
                        key={linkIndex}
                        sx={{ ...bubbleSx, bgcolor: "blue" }}
                      >
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {link}
                        </a>
                      </Box>
                    )
                )}
            </Box>
          </TimelineContent>
        </TimelineItem>
      );

    });
  });

  // End マーカー
  items.push(
    <TimelineItem key="end" sx={itemSx}>
      <TimelineSeparator sx={separatorSx}>
        <TimelineConnector sx={connectorSx} />
        <TimelineDot variant="outlined" sx={markerDotSx}>
          <Typography sx={{ fontSize: "11px", color: "#333" }}>End</Typography>
        </TimelineDot>
      </TimelineSeparator>
      <TimelineContent />
    </TimelineItem>
  );

  return (
    <Timeline position="right" sx={{ p: 0, m: 0 }}>
      {items}
    </Timeline>
  );
}

export default TravelTimeline;
